const screenSizes = {
  sm: 375,
  "sm-2": 560,
  md: 768,
  lg: 960,
  xl: 1200,
  xxl: 1600
};
const isMobile = (screen = "md") => {
  return !window.matchMedia(`(min-width: ${screenSizes[screen]}px)`).matches;
};
export {
  isMobile
};
//# sourceMappingURL=is-mobile.js.map
